import { Font } from '@react-pdf/renderer';
import { AppDecorator } from 'src/app/decorators/AppDecorator';
import { NotificationsProvider } from 'src/app/providers/NotificationsProvider';
import { AppRouter } from 'src/app/router/ui/AppRouter';

export const App = () => {
	Font.register({
		family: 'Poppins, sans-serif',
		fonts: [
			{
				src: '/fonts/Poppins-Regular.ttf',
			},
			{
				src: '/fonts/Poppins-Bold.ttf',
				fontWeight: 'bold',
			},
			{
				src: '/fonts/Poppins-Light.ttf',
				fontWeight: 'light',
			},
		],
	});

	Font.register({
		family: 'Montserrat, sans-serif',
		fonts: [
			{
				src: '/fonts/Montserrat-Light.ttf',
				fontWeight: 'light',
			},
			{
				src: '/fonts/Montserrat-Medium.ttf',
				fontWeight: 'medium',
			},
			{
				src: '/fonts/Montserrat-Regular.ttf',
				fontWeight: 'normal',
			},
		],
	});

	Font.register({
		family: 'Ubuntu, sans-serif',
		fonts: [
			{
				src: '/fonts/Ubuntu-Light.ttf',
				fontWeight: 'light',
			},
			{
				src: '/fonts/Ubuntu-Medium.ttf',
				fontWeight: 'medium',
			},
			{
				src: '/fonts/Ubuntu-Regular.ttf',
				fontWeight: 'normal',
			},
		],
	});

	return (
		<>
			<AppDecorator>
				<NotificationsProvider />
				<AppRouter />
			</AppDecorator>
		</>
	);
};
